import React, { useState, useEffect, useRef } from "react";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import DeleteModal from "./Assets/DeleteModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const fileInputRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const [categories, setCategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [preview, setPreview] = useState("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
  const [preview1, setPreview1] = useState("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
  id: "",
  services_id:"",
  title: "",
  description1: "",
  description2: "",
  features: "",
  keyBenifets: "",
  icon: "",
  isPopular: "0",
});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://viklang.serverscripts.in/api/v1/services/view", {
        method: "GET",
         headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
          },
      });
        if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }

      const result = await response.json();
      if (result.success) setCategories(result.data);
      else toast.error(result.message || "Failed to fetch categories");
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch categories");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    setProcessing(true);
  e.preventDefault();

  if (!formData.title.trim()) {
    toast.error("Title is required!");
    return;
  }

  try {
    const token = localStorage.getItem("authToken");
    const form = new FormData();

    form.append("id", formData.id);
    form.append("services_id", formData.services_id);
    form.append("title", formData.title);
    form.append("description1", formData.description1);
    form.append("description2", formData.description2);
    form.append("features", formData.features);
    form.append("keyBenifets", formData.keyBenifets);
    form.append("icon", formData.icon);
    form.append("isPopular", formData.isPopular);

    if (file) form.append("image", file);
    if (file1) form.append("image1", file1);

    const url = editId
      ? "https://viklang.serverscripts.in/api/v1/services/edit"
      : "https://viklang.serverscripts.in/api/v1/services/add";

    const response = await fetch(url, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    });
    console.log(form);
    console.log("jhd",formData);
    
    const data = await response.json();
    console.log(data);

    if (data.success) {
      setProcessing(false);
      toast.success(data.message);
      setFormData({
        id: "",
        title: "",
        description1: "",
        description2: "",
        features: "",
        keyBenifets: "",
        icon: "",
        isPopular: "0",
      });
      setEditId(null);
      setFile(null);
      setPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
      setPreview1("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
      if (fileInputRef.current) fileInputRef.current.value = "";
      if (fileInputRef1.current) fileInputRef1.current.value = "";
      fetchData();
    } else {
      toast.error(data.message || "Failed to save service");
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong!");
  }
};


const handleEdit = (id) => {
  const s = categories.find((c) => c.id === id);
  if (s) {
    setFormData({
      id: s.id,
      services_id: s.services_id,
      title: s.title,
      description1: s.description1,
      description2: s.description2,
      features: s.features,
      keyBenifets: s.keyBenifets,
      icon: s.icon,
      isPopular: s.isPopular,
    });

    setPreview(s.img || "https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
    setPreview1(s.img1 || "https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
    setEditId(id);
  }
};

  const cancelEdit = () => {
    setFormData({ id: "", title: "", description1: "", description2: "", features: "", keyBenifets: "", icon: "", isPopular: "0" });
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    console.log("ud",id);
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {
      console.log("dvcg",itemToDelete)
      const token = localStorage.getItem("authToken");
      const response = await fetch(`https://viklang.serverscripts.in/api/v1/services/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: itemToDelete }),
      });
      const data = await response.json();
     
      if (data.success) {
        toast.success(data.message);
        setCategories((prev) => prev.filter((cat) => cat.services_id !== itemToDelete));
      } else {
        toast.error(data.message || "Failed to delete services");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete services");
    } finally {
      setDeleteModalShow(false);
      setItemToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const loadFile = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setPreview(URL.createObjectURL(selectedFile));
      setFile(selectedFile);
    }
  };
    const loadFile1 = (e) => {
    const selectedFile1 = e.target.files[0];
    if (selectedFile1) {
      setPreview1(URL.createObjectURL(selectedFile1));
      setFile1(selectedFile1);
    }
  };

  return (
<div className="role-settings-container">
      <div className="bg-white p-[1vw] role-settings-form-container">
        <div className="text-[20px] font-bold border-b border-gray-300 pb-[2px] text-gray-600">
          <h1>{editId ? "Update Services" : "Add Services"}</h1>
        </div>

        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Id *
            </label>
            <input
              name="id"
              value={formData.id}
              onChange={(e) =>
                setFormData({ ...formData, id: e.target.value })
              }
              type="text"
              placeholder="Enter Id"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Title *
            </label>
            <input
              name="title"
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
              type="text"
              placeholder="Enter Services Name"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Description 1 *
            </label>
            <input
              name="description1"
              value={formData.description1}
              onChange={(e) =>
                setFormData({ ...formData, description1: e.target.value })
              }
              type="text"
              placeholder="Enter Description (1)"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Description 2 *
            </label>
            <input
              name="description2"
              value={formData.description2}
              onChange={(e) =>
                setFormData({ ...formData, description2: e.target.value })
              }
              type="text"
              placeholder="Enter Description (2)"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Features (separated by commas)*
            </label>
            <input
              name="features"
              value={formData.features}
              onChange={(e) =>
                setFormData({ ...formData, features: e.target.value })
              }
              type="text"
              placeholder="Please enter the features, separated by commas."
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Key Benifets (separated by commas)*
            </label>
            <input
              name="keyBenifets"
              value={formData.keyBenifets}
              onChange={(e) =>
                setFormData({ ...formData, keyBenifets: e.target.value })
              }
              type="text"
              placeholder="Please enter the key points, separated by commas."
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              icon *
            </label>
            <input
              name="icon"
              value={formData.icon}
              onChange={(e) =>
                setFormData({ ...formData, icon: e.target.value })
              }
              type="text"
              placeholder="Please enter Icon."
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Is New *
            </label>

            <select
              name="isPopular"
              value={formData.isPopular}
              onChange={(e) =>
                setFormData({ ...formData, isPopular: Number(e.target.value) })
              }
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            >
              <option value="">Select an option</option>
              <option value={1}>Yes</option>
              <option value={0}>No</option>
            </select>
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Upload 1st Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={loadFile}
              ref={fileInputRef}
              className="block w-full"
            />
            {preview && (
              <img
                src={preview}
                alt="Preview"
                className="mt-2 w-32 h-32 object-cover  rounded-lg "
              />
            )}
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Upload 2nd Image 
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={loadFile1}
              ref={fileInputRef1}
              className="block w-full"
            />
            {preview && (
              <img
                src={preview1}
                alt="Preview"
                className="mt-2 w-32 h-32 object-cover  rounded-lg "
              />
            )}
          </div>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              disabled={processing}  
            >
              {processing
                ? editId
                  ? "Updating..."
                  : "Saving..."
                : editId
                  ? "Update"
                  : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={() => {
                  setFormData({id: "", title: "", description1: "", description2: "", features: "", keyBenifets: "", icon: "", isPopular: "0" });
                  setEditId(null);
                  setFile(null);
                  setPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
                  setPreview1("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
                }}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
      <ul className="w-full role-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Services List</h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-5">
                        <th className="px-4 py-2 text-left">#</th>
                        <th className="px-4 py-2 text-left">Image</th>
                        <th className="px-4 py-2 text-left">Services</th>
                        <th className="px-4 py-2 text-left">Description</th>
                        <th className="px-4 py-2 text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {categories.length > 0 ? (
                        categories.map((cat, index) => (
                          <tr className="grid grid-cols-5" key={cat.id}>
                            <td className="px-4 py-2">{index + 1}</td>
                            <td className="py-3 px-4 flex items-center gap-3">
                              <img
                                src={cat.img}
                                alt={cat.title}
                                className="h-16 w-16 object-cover "
                              />
                              
                            </td>
                            <td className="py-3 px-4 flex items-center gap-3">
                             
                              <div>
                                <div className="font-semibold text-gray-800">
                                  {cat.title}
                                </div>
                               
                              </div>
                            </td>
                            <td className="py-3 px-4 flex items-center gap-3">
                             
                              <div>
                                <div className="font-semibold text-gray-600">
                                  {truncateText(cat.description1, 100)}
                                </div>
                               
                              </div>
                            </td>
                            
                            
                            <td className="px-4 py-2">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(cat.id)}
                                  className="text-blue-500 hover:text-blue-700 text-[20px]"
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(cat.services_id)}
                                  className="text-red-500 hover:text-red-700 text-[20px]"
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="p-2 text-center">
                            No categories found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>

      {deleteModalShow && (
        <DeleteModal
          itemName={
            categories.find((p) => p.services_id === itemToDelete)?.title ||
            "Unknown"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Services;

const truncateText = (text, maxLength = 100) => {
  if (!text) return "—";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};